"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var HudledLogo_1 = __importDefault(require("components/modules/components/HudledLogo"));
var Headline_1 = __importDefault(require("./styles/Headline"));
var WelcomeSection = function (_a) {
    var welcomeMsg = _a.welcomeMsg, description = _a.description;
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ width: 280, display: "flex", flexDirection: "column", alignItems: { xs: 'center', md: 'flex-start' } }, { children: [(0, jsx_runtime_1.jsx)(HudledLogo_1.default, { height: 48 }), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 2 }, { children: (0, jsx_runtime_1.jsx)(Headline_1.default, { children: welcomeMsg }) })), (0, jsx_runtime_1.jsx)(material_1.Box, { children: description })] })));
};
exports.default = WelcomeSection;
